export default {
  WelcomeMessage: 'Bienvenido a Spore',
  InputDataMessage: 'Ingresa tus datos',
  EmailLabel: 'Correo',
  PasswordLabel: 'Contraseña',
  ForgotPassword: '¿Olvidaste tu contraseña?',
  Enter: 'Ingresar',
  Messages: {
    ErrorLogin: 'Credenciales incorrectas.',
    MissingParams: 'Favor de llenar los campos',
    Alert: 'Alerta',
    Correct: 'Correcto',
    State: 'Estado',
    RequiredFields: 'Campo Obligatorio | Campos obligatorios',
    EnterPassword: 'Ingresa tu contraseña para continuar'
  },
  Labels:{
    Min: 'Mín',
    Max: 'Máx',
    Time: 'Tiempo',
    TimeUnity: 'Unidad de Tiempo',
    DeviceLocation: 'Ubicación del dispositivo',
    Alerts: 'Alertas',
    DeviceInformation: 'Información del dispositivo',
    ReportTime: 'Tiempo de reporteo',
    GroundTemperature: 'Temperatura del suelo',
    EnvTemperature: 'Temperatura del ambiente',
    Humidity: 'Humedad',
    HumidityGround: 'Humedad del suelo',
    Precipitation: 'Precipitación',
    Light: 'Nivel de luz',
    Save: 'Guardar',
    Filter: 'Filtrar',
    DeviceName: 'Nombre del dispositivo',
    DevEui: 'DevEui',
    Serie: 'Serie',
    Port: 'Puerto',
    Activate: 'Activar',
    Profile: 'Perfil',
    AppId: 'Aplicación Id',
    Description: 'Descripción',
    App: 'Aplicación | Aplicaciones',
    Status: 'Estado',
    DevAddress: 'Dirección de dispositivo',
    AppKey: 'Llave de aplicación',
    NetworkKey: 'Llave de red',
    License: 'Licencia | Licencias',
    Creator: 'Usuario creador',
    Modifier: 'Usuario modificador',
    CreatedAt: 'Fecha de creación',
    UpdatedAt: 'Fecha de actualización',
    Confirm: 'Confirmar',
    Accept: 'Aceptar',
    Cancel: 'Cancelar',
    Client: 'Cliente',
    Start: 'Inicia',
    Expire: 'Expira',
    Add: 'Agregar',
    Detail: 'Detalle',
    PublicKey: 'Llave pública',
    PrivateKey: 'Llave privada',
    Name: 'Nombre',
    Device: 'Dispositivo | Dispositivos',
    Network: 'Red',
    Organization: 'Organización',
    Companies: 'Compañías',
    Company: 'Compañía',
    ContactName: 'Nombre del Contacto',
    Address:'Dirección',
    PhoneNumber: 'Teléfono',
    DeviceProfiles: 'Perfiles de dispositivo',
    Licenses:'Licencias',
    Apps:'Aplicaciones',
    Assignments:'Asignaciones',
    GoTo:'Ir a',
    DeviceType: 'Tipo de Dispositivo',
    LastSeen: 'Última visualización',
    Type: 'Tipo',
    General: 'General',
    ClassB:'Clase B',
    SupportClassB: 'Soporta Clase B',
    ClassC:'Clase C',
    SupportClassC: 'Soporta Clase C',
    Codec:'Codec',
    Region: 'Region',
    Uplink:'Uplink',
    Timeout: 'Tiempo',
    EncoderScript: 'Encoder Script',
    DecoderScript: 'Decoder Script',
    Next:'Siguiente',
    Back:'Anterior',
    MacVersion: 'Versión MAc',
    Active: 'Activa',
    Inactive: 'Inactiva',
    Expired: 'Expirada',
    Search: 'Buscar',
    All: 'Todos',
    From: 'De',
    To:'Hasta',
    SelectOne: 'Selecciona una opción',
    Param: 'Parámetro',
    Test: 'Probar',
    Result: 'Resultado',
    Confirm: 'Confirmar',
    Assign: 'Asignar',
    Validity: 'Vigencia',
    TimeToExpire: 'Tiempo para expirar',
    Report: 'Reporte',
    Edit: 'Editar',
    Download: 'Descargar',
    Delete: 'Eliminar',
    File: 'Archivo',
    Close: 'Cerrar',
    Finish: 'Finalizar',
    Created: 'Creada',
    Asigned: 'Asignada',
    
  },
  Apps:'Aplicaciones',
  Licenses: 'Licencias',
  Devices: 'Dispositivos',
  Logout: 'Cerrar sesión',
  DeviceProfiles: 'Perfiles de dispositivo',
  ChangeHistory: 'Historial de Cambios',
  Companies: 'Compañías',
  DeviceTypes: 'Tipos de dispositivos',
  Dashboard: 'Estadísticas',
  Path:{
    Apps: 'Aplicaciones',
    List: 'Listado',
    Add: 'Agregar',
    Detail: 'Detalle',
    Edit: 'Editar',
    Licenses: 'Licencias',
    Report: 'Reporte',
    Devices: 'Dispositivos',
    Companies: 'Compañías',
    Profiles: 'Perfiles',
    DeviceTypes: 'Tipos de dispositivos'
  }
   
}
